import { ErrorStateScheduleEnum } from '../error-state-schedule.enum';

export enum PanelPlansResolverErrorStatesEnum {
    GetPlanTypesFailed = ErrorStateScheduleEnum.PanelPlansResolverErrorStatesStartIndex,
    GetInitialDataFailed
}